module.exports = __webpack_public_path__ + "static/media/item-border-selected-NC.5901e10a.svg";